module.exports = __webpack_public_path__ + "google-touch-icon-65a9918c98941a0cbcd7d8d8bacc53b3.png";